module.exports = {
  CAL_AG_PUR_SUBMIT: 'CAL_AG_PUR_SUBMIT',
  CAL_AG_NOI_SUBMIT: 'CAL_AG_NOI_SUBMIT',
  CAL_AG_MSPUR_SUBMIT: 'CAL_AG_MSPUR_SUBMIT',
};
